import { render } from "./bottomNav.vue?vue&type=template&id=784c1176"
const script = {}

import "./bottomNav.vue?vue&type=style&index=0&id=784c1176&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__